






























import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import tableModel from '../../components/table/tableModel.vue';
import moment from 'moment';
@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class AccountProfit extends Vue {
  private user: any;
  private dateFormat = 'YYYY-MM-DD';
  private moment: any = moment;
  private dataTime: any = moment(new Date()).add(-2, 'days').format('YYYY-MM-DD');
  private spinning = false;
  private isTable = false;
  private dataJson: any = [];
  private columns: any = [{
    title: 'Date',
    dataIndex: 'date',
    width: '10%',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Account',
    dataIndex: 'account',
    width: '10%',
    scopedSlots: { customRender: 'account' },
  },
  {
    title: 'Profit',
    dataIndex: 'profit',
    width: '10%',
    scopedSlots: { customRender: 'profit' },
  }];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('is login');
      this.getData();
    } else {
     this.$router.push({
        path: '/login',
      });
    }

  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getAccountProfit';
    const dataTime = [moment(this.dataTime).format('YYYY-MM-DD')];
    const args = {
      time: dataTime,
    };
    const data = await this.axios.post(url, args);
    this.dataJson = data.data.data;
    console.log(this.dataJson);

    this.spinning = false;
    this.isTable = true;

  }
  private onPickerChange(date: any, dateString: string) {
    // console.log('sss   ' + dateString);
    this.dataTime = dateString;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.SKUkeyInput as HTMLInputElement;
    inputBox.focus();
  }
}
